import React from 'react';
import {Link as RouterLink} from 'react-router-dom'
import {concatenate} from "services/string";
import LocationState from "../../types/LocationState";

type Props = {
    to: string
    children: React.ReactNode
    noDecoration?: boolean
    download?: boolean
    state?: LocationState
}

// noinspection HttpUrlsUsage
const externalPrefixes = ['http://', 'https://', 'mailto:', 'tel:']

// Classes
const fontClasses = "font-semibold"
const textClasses = "text-brand transition-all duration-200"
const borderClasses = "border-b border-dashed border-brand"

function Link({to, children, download, noDecoration, state}: Props) {
    const classes = concatenate(
        !noDecoration? borderClasses : null,
        !noDecoration? textClasses : null,
        fontClasses
    )

    return externalPrefixes.some(prefix => to.startsWith(prefix))?
        (<a href={to} className={classes} target={download? "_self" : "_blank"} rel={download? "" : "noreferrer nofollow"}>{children}</a>) :
        (<RouterLink to={to} state={state} className={classes}>{children}</RouterLink>)
}

export default Link;